import React, { useState } from 'react';
import { DefinedRange, createStaticRanges } from 'react-date-range';
import {
    addDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek
} from 'date-fns';

export default function DateRange(props) {
    const defineds = {
        startOfWeek: startOfWeek(new Date()),
        endOfWeek: endOfWeek(new Date()),
        startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
        endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
        startOfToday: startOfDay(new Date()),
        endOfToday: endOfDay(new Date()),
        startOfYesterday: startOfDay(addDays(new Date(), -1)),
        endOfYesterday: endOfDay(addDays(new Date(), -1)),
        startOfMonth: startOfMonth(new Date()),
        endOfMonth: endOfMonth(new Date()),
        startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
        endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
        startOfLastSixMonth: startOfMonth(addMonths(new Date(), -5)),
        endOfLastSixMonth: endOfMonth(new Date())
    };

    const predefinedRanges = createStaticRanges([
        {
            label: 'Last Week',
            range: () => ({
                startDate: defineds.startOfLastWeek,
                endDate: defineds.endOfLastWeek,
                label: 'Last Week'
            })
        },
        {
            label: 'Last Month',
            range: () => ({
                startDate: defineds.startOfLastMonth,
                endDate: defineds.endOfLastMonth,
                label: 'Last Month'
            })
        },
        {
            label: 'Last 6 Month',
            range: () => ({
                startDate: defineds.startOfLastSixMonth,
                endDate: defineds.endOfLastSixMonth,
                label: 'Last 6 Month'
            })
        },
        {
            label: 'All Time',
            range: () => ({
                startDate: new Date(0),
                endDate: new Date(),
                label: 'All Time'
            })
        }
    ]);

    const [state, setState] = useState(
        !props.range
            ? [
                  {
                      startDate: new Date(0),
                      endDate: new Date(),
                      key: 'selection'
                  }
              ]
            : [
                  {
                      startDate: new Date(props.range.startDate),
                      endDate: new Date(props.range.endDate),
                      key: 'selection'
                  }
              ]
    );

    return (
        <DefinedRange
            onChange={(item) => {
                setState([item.selection]);
                props.filterRowsOnDate(item.selection);
            }}
            ranges={state}
            staticRanges={predefinedRanges}
        />
    );
}
